var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-left-solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.493,
    viewBox: "0 0 20 19.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-left-solid-2",
    "data-name": "arrow-left-solid",
    d: "M11.446,55.838l-.991.991a1.067,1.067,0,0,1-1.513,0L.265,48.156a1.067,1.067,0,0,1,0-1.513l8.678-8.678a1.067,1.067,0,0,1,1.513,0l.991.991a1.073,1.073,0,0,1-.018,1.531L6.05,45.611H18.879a1.069,1.069,0,0,1,1.071,1.071v1.428a1.069,1.069,0,0,1-1.071,1.071H6.05l5.379,5.124a1.065,1.065,0,0,1,.018,1.531Z",
    transform: "translate(0.05 -37.65)",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSolid);
export default __webpack_public_path__ + "static/media/arrow-left-solid.09e9c903402eac085a24e8c883264a13.svg";
export { ForwardRef as ReactComponent };